module.exports = __webpack_public_path__ + "img/btn_menu-close.3fbb6af9.png";